"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6601],{

/***/ 20841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77869);
/* harmony import */ var segments_desktop_core_components_title_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51261);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_desktop_core_components_title_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z), {
    textAlign: "left",
    titleSize: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.LG
}));


/***/ }),

/***/ 87870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TitleOnlyParagraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 22 modules
var button_button = __webpack_require__(16430);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/title-only-paragraph/title-only-paragraph.scss.js

var StyledTitleOnlyParagraph = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ept3tlo0"
})("word-break:break-word;width:100%;.button-wrapper{margin-top:32px;display:flex;&.left{justify-content:flex-start;}&.center{justify-content:center;}&.right{justify-content:flex-end;}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/title-only-paragraph/default-props.js
var default_props = __webpack_require__(20841);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
;// CONCATENATED MODULE: ./segments/desktop/core-components/title-only-paragraph/title-only-paragraph.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}








var TitleOnlyParagraph = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TitleOnlyParagraph, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TitleOnlyParagraph);
    function TitleOnlyParagraph() {
        (0,_class_call_check/* default */.Z)(this, TitleOnlyParagraph);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TitleOnlyParagraph, [
        {
            key: "getComponentInlineStyles",
            value: function getComponentInlineStyles() {
                var _props = this.props, textAlign = _props.textAlign, textColor = _props.textColor, fontSize = _props.fontSize, titleSize = _props.titleSize;
                var inlineStyles = {
                    textAlign: textAlign,
                    color: colors/* default */.Z[textColor]
                };
                if (!titleSize) inlineStyles.fontSize = fontSize;
                return inlineStyles;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, buttonConfig = _props.buttonConfig, textAlign = _props.textAlign, titleSize = _props.titleSize, isFirstSegment = _props.isFirstSegment, titleColor = _props.titleColor;
                var inlineComponentStyles = this.getComponentInlineStyles();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTitleOnlyParagraph, {
                    className: "title-only-paragraph",
                    style: inlineComponentStyles,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                            title: title,
                            titleSize: titleSize,
                            isFirstSegment: isFirstSegment,
                            titleColor: titleColor
                        }),
                        buttonConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("button-wrapper", textAlign),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, _object_spread({}, buttonConfig))
                        })
                    ]
                });
            }
        }
    ]);
    return TitleOnlyParagraph;
}(react.PureComponent);

TitleOnlyParagraph.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 96601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TitleOnlyParagraphComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/title-only-paragraph/title-only-paragraph.js + 1 modules
var title_only_paragraph = __webpack_require__(87870);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/title-only-paragraph/title-only-paragraph-component.scss.js


var StyledTitleOnlyParagraphComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ec4d43y0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;.title-only-paragraph-wrapper{max-width:1100px;margin:auto;display:flex;justify-content:center;padding:0px 32px;}");

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/title-only-paragraph/title-only-paragraph-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var TitleOnlyParagraphComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TitleOnlyParagraphComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TitleOnlyParagraphComponent);
    function TitleOnlyParagraphComponent() {
        (0,_class_call_check/* default */.Z)(this, TitleOnlyParagraphComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TitleOnlyParagraphComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitleOnlyParagraphComponent, {
                    className: "title-only-paragraph-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title-only-paragraph-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title_only_paragraph/* default */.Z, _object_spread({}, this.props))
                    })
                });
            }
        }
    ]);
    return TitleOnlyParagraphComponent;
}(react.PureComponent);

TitleOnlyParagraphComponent.defaultProps = _object_spread_props(_object_spread({}, title_only_paragraph/* default.defaultProps */.Z.defaultProps), {
    paddingTop: "64px",
    paddingBottom: "64px"
});


/***/ })

}]);